import React from 'react';
import { Image as ImageIcon, Globe, FileText, Sparkles, Music, Video } from 'lucide-react';
import type { Activity, ActivityKind } from '../../utils/chatActivity';
import { TYPE } from '../../constants/typeScale';

const ICON: Record<ActivityKind, React.FC<{ className?: string }>> = {
  image: ImageIcon, music: Music, video: Video, research: Globe, artifact: FileText, thinking: Sparkles,
};

/**
 * A slim, non-intrusive activity bar — surfaces what the agents are doing on the current
 * turn (research / image / artifact / thinking) without blocking the composer. Sits just
 * above the input; renders nothing when idle.
 */
const ChatActivityBar: React.FC<{ activity: Activity | null }> = ({ activity }) => {
  if (!activity) return null;
  const Icon = ICON[activity.kind];
  return (
    <div
      data-testid="chat-activity-bar"
      className={`flex items-center gap-2 px-4 py-1.5 ${TYPE.control} text-secondary-500 dark:text-secondary-400 border-t border-secondary-100 dark:border-secondary-600 bg-secondary-50/60 dark:bg-secondary-900/60`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-secondary-400 opacity-75 animate-ping" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-secondary-500" />
      </span>
      <Icon className="h-3.5 w-3.5" />
      <span>{activity.label}</span>
    </div>
  );
};

export default ChatActivityBar;
